import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';
import { Check, X, Loader2 } from 'lucide-react';

export default function CheckoutReturn() {
  const { t, api, clearCart } = useApp();
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState('polling');
  const [details, setDetails] = useState(null);
  const navigate = useNavigate();
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { navigate('/'); return; }
    const tick = async () => {
      if (attempts.current >= 8) { setStatus('timeout'); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        setDetails(data);
        if (data.payment_status === 'paid') { setStatus('paid'); clearCart(); return; }
        if (data.status === 'expired') { setStatus('expired'); return; }
        setTimeout(tick, 2200);
      } catch {
        setTimeout(tick, 2500);
      }
    };
    tick();
  }, [sessionId, api, clearCart, navigate]);

  return (
    <div className="max-w-xl mx-auto px-6 py-32 text-center" data-testid="checkout-return">
      {status === 'polling' && (<>
        <Loader2 size={40} strokeWidth={1} className="mx-auto animate-spin text-accent" />
        <h1 className="font-display text-4xl mt-8">{t('checkout.processing')}</h1>
      </>)}
      {status === 'paid' && (<>
        <Check size={48} strokeWidth={1} className="mx-auto text-accent" />
        <h1 className="font-display text-4xl mt-8" data-testid="checkout-success">{t('checkout.success')}</h1>
        <p className="mt-4 font-light text-muted-foreground">Order total: ${((details?.amount_total || 0) / 100).toLocaleString()}</p>
        <button onClick={() => navigate('/account')} className="mt-10 bg-foreground text-background px-8 py-4 overline">View Orders</button>
      </>)}
      {(status === 'expired' || status === 'timeout') && (<>
        <X size={40} strokeWidth={1} className="mx-auto text-destructive" />
        <h1 className="font-display text-4xl mt-8">{t('checkout.failed')}</h1>
        <button onClick={() => navigate('/cart')} className="mt-10 bg-foreground text-background px-8 py-4 overline">Back to Cart</button>
      </>)}
    </div>
  );
}
